// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__iqYtP","input":"SearchBar_input__ZMM8m","submit":"SearchBar_submit__xPkO0","icon":"SearchBar_icon__015GN"};